import React from "react";
import CustomNavbar from "../components/CustomNavbar";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/Footer/FooterTwo";
import FooterData from "../components/Footer/FooterData";


const phsCad = () => {
    let manufactutingList = [
        "Quality Control Manual",
        "BS3974 - Specification for Pipe Supports",
        "MSS-SP69 - Pipe Hangers and Supports, and steel fabrication",
        "MSS-SP89",
        "ANSI - B31.1 - Power Piping",
        "ANSI - B31.3 - Petroleum Refinery Piping",
     ];

     let qualityAssuranceList = [
         "Customer Satisfaction",
         "Supplier Assessment",
         "Delivery Performance",
         "Quality Performance",
     ];
  return (
    <div className="body_wrapper">
      <CustomNavbar
        slogo="sticky_logo"
        mClass="menu_four"
        nClass="w_menu ml-auto mr-auto"
      />
      <Breadcrumb
        breadcrumbClass="breadcrumb_area"
        imgName="breadcrumb/banner_bg.png"
        Ptitle="Quality"
        Pdescription=""
      />
      <section className="contact_info_area sec_pad bg_color">
        <div className="container">
          <h6 className="f_p f_size_20 t_color3 f_500 mb_20">Quality Control</h6>
          <p>We have a fully staffed Quality Control department responsible for the Quality of the finished product confirming to domestic and international standards.</p>
          <p className="f_600">Manufacturing Standards commonly used:</p>
          <ul className="list-unstyled p_body">
              {manufactutingList.map((x) => (
                   <li className="mt-3"> <i class="icon_check_alt2"></i>  {x}</li>
              )
              )}
             
          </ul>
          <h6 className="f_p f_size_20 t_color3 f_500 mb_20">Documentation</h6>
          <p>Pipe Hangers & Supports has setup a full fledged documentation center with the latest scanners, photocopiers etc., for producing final documentation to third party inspectors, consultants and clients. The market has moved to an electronic format with more clients requesting CDs in place of hardcopies. This helps to protect & save our environment.</p>

          <h6 className="f_p f_size_20 t_color3 f_500 mb_20">Quality Assurance</h6>
          <p>PHSPL employs a highly skilled team of designers, engineers, production, and marketing experts within an ISO 9001:2008 quality framework.</p>
          <p>Our offices and production facilities adhere to strict safety practices and procedures, and strive for continuous improvement, which is driven by the following Key Performance Indicators:</p>

          <ul className="list-unstyled p_body">
              {qualityAssuranceList.map((x) => (
                   <li className="mt-3"> <i class="icon_check_alt2"></i>  {x}</li>
              )
              )}
             
          </ul>
          <p>On-going training, multi-skilling, and co-operation are also actively encouraged.</p>

          <h6 className="f_p f_size_20 t_color3 f_500 mb_20">Quality Policy</h6>


          
        </div>
      </section>
      <FooterTwo FooterData={FooterData} />
    </div>
  );
};

export default phsCad;
